<template>
  <mdb-card class="my-3 rgba-grey-slight">
    <mdb-card-body>
      <mdb-input outline type="textarea" :rows="3" class="my-0 white" v-model="content"/>
      <div class="text-right">
        <mdb-btn @click='onOk' icon="check" class="p-2 " :disabled="!content.trim()"> 등록</mdb-btn>
      </div>
    </mdb-card-body>
  </mdb-card>
</template>
<script>
import { mdbIcon, mdbBtn, mdbAlert, mdbInput, mdbCard, mdbCardBody } from 'mdbvue';
import { mapState, mapMutations, mapActions } from 'vuex';
import ActionType from '@/store/modules/article/ActionType.js';
export default {
  name: 'CommentWrite',
  components: { mdbCard, mdbCardBody, mdbInput, mdbBtn },
  props: ['article'],
  data: () => ({
    content: ''
  }),
  computed: mapState('auth', ['profile']),
  methods: {
    ...mapActions('article', [ActionType.ARTICLE_COMMENT]),
    async onOk () {
      if (!confirm('저장할까요?')) return
      let comment = this.$Comment.create(this.article._id, this.profile._id, this.content)
      comment = await comment.save()
      this.content = ''
      this.$emit('add-comment', comment)
    }
  }
}
</script>
